export const h = {
    "common": {
        "webSuffix": "- QIDI Tech QIDI Technology",
        "email": "Buzón",
        "password": "Contraseña",
        "verificationCode": "Código de verificación",
        "username": "Nombre de usuario",
        "readAndAgree": "Estoy de acuerdo.",
        "and": "Y",
        "userAgreement": "Protocolo de usuario",
        "privacyPolicy": "Política de privacidad",
        "copy": "Todos los derechos de autor ©  2025 Qi di se reserva la propiedad",
        "sendVerificationCode": "Enviar Código de verificación",
        "Sending": "Enviado",
        "tryAgainInSeconds": "Intenta de nuevo después de segundos",
        "userNameRequired": "Introduzca el nombre de usuario",
        "passwordInputLabel": "Por favor, introduzca la contraseña",
        "checkPasswordInputLabel": "Introduzca la contraseña de confirmación",
        "userEmailRequired": "Por favor, introduzca la dirección del buzón.",
        "userEmailInvalid": "Introduzca la dirección de correo electrónico correcta",
        "emailCodeRequired": "Por favor, introduzca el Código de verificación",
        "newPasswordInputLabel": "Por favor, introduzca una nueva contraseña",
        "confirmPasswordInputLabel": "Introduzca la contraseña de nuevo",
        "passwordMismatchErrorLabel": "Dos contraseñas de entrada inconsistentes",
        "agreementRequired": "Lea y acepte el Acuerdo",
        "tip": "Consejos",
        "tipAlreadyLogin": "Se detecta que se ha iniciado sesión y se salta al Centro de usuarios para usted",
        "tipWelcomeBack": "Bienvenido de vuelta.",
        "tipDeleteAccountFail": "La eliminación de la cuenta falló y la interfaz de eliminación de la cuenta se cerró temporalmente.",
        "pleaseAgreeFirst": "Por favor, acepte primero.",
        "agree": "De acuerdo",
        "refuse": "Rechazar",
        "tipNeedLogin": "Por favor, inicie sesión primero",
        "tipChangePasswordSuccess": "Se modificó con éxito la contraseña y se saltó a la página de inicio de sesión para usted.",
        "tipGetUserInfoSuccess": "Acceso exitoso a la información",
        "tipGetUserInfoFail": "Falló el acceso a la información",
        "tipLoginOut": "Salir de inicio de sesión",
        "delete": "Eliminar",
        "back": "Volver",
        "init": "Iniciación",

        "passwordInputLengthErrorLabel": "La longitud de la contraseña debe estar entre 6 y 20",
        "changePasswordFail": "Error en la contraseña original",
        "tipDeleteAccountSuccess": "Se eliminó con éxito la cuenta",
        "emailCodeSentSuccess": "Se ha emitido el Código de verificación",
        "emailCodeSentFail": "Falló la emisión del Código de verificación",
        "emailLoginFail": "El Código de verificación ha expirado",
        "passwordLoginFail": "Error en la contraseña de inicio de sesión",
        "editUserInfoSuccess": "Modificación exitosa de la información del usuario",
        "registerSuccess": "Registro exitoso",
        "registerFail": "Falló el registro",
        "registerEmailExistFail": "El buzón ya existe",

        "resMessageTip0": "Información desconocida",
        "resMessageTip1": "Error de contraseña",
        "resMessageTip2": "La longitud de la contraseña debe estar entre 6 y 20",
        "resMessageTip3": "Error en la cuenta",
        "resMessageTip4": "Se ha emitido el Código de verificación",
        "resMessageTip5": "Falló la emisión del Código de verificación",
        "resMessageTip6": "El Código de verificación ha expirado",
        "resMessageTip7": "Error de contraseña",
        "resMessageTip8": "La contraseña no puede ser la misma que la antigua",
        "resMessageTip9": "El buzón ya existe",
        "resMessageTip10": "Registro exitoso",
        "resMessageTip11": "Falló el registro",
        "resMessageTip12": "Modificación exitosa de la información del usuario",
        "resMessageTip13": "Falló la modificación de la información del usuario",
        "resMessageTip14": "Lograr el éxito",
        "resMessageTip15": "Obtención fallida",
        "resMessageTip16": "Se modificó con éxito la contraseña",
        "resMessageTip17": "Falló la modificación de la contraseña",
        "resMessageTip18": "Restablecer la contraseña con éxito",
        "resMessageTip19": "Falló el restablecimiento de la contraseña",
        "resMessageTip20": "Inicio de sesión exitoso",
        "resMessageTip21": "Falló el inicio de sesión",
        "resMessageTip22": "Se eliminó con éxito la cuenta",
        "resMessageTip23": "Falló la eliminación de la cuenta",
        "resMessageTip24": "El Código de verificación es incorrecto",
        "noUserInfoError": "Error de red, vuelva a iniciar sesión"
    },
    "changePassword": {
        "newPassword": "Nueva contraseña"
    },
    "deleteUser": {
        "tipDeleteUser": "Es una pena que se vaya. Una vez eliminada su cuenta, todos sus datos personales desaparecerán permanentemente e irrecuperables.",
        "accountDeletionTerms": "Cláusula de eliminación de cuenta"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Recuperar la contraseña a través del buzón",
        "confirmPassword": "Confirmar contraseña",
        "resettingPassword": "Restablecer la contraseña",
        "resetting": "Restablecer"
    },
    "login": {
        "passwordLogin": "Inicio de sesión con contraseña",
        "verifyLogin": "Verificar inicio de sesión",
        "accountRegistration": "Registro de cuentas",
        "forgotPassword": "Olvida la contraseña",
        "login": "Iniciar sesión",
        "localLogin": "Inicio de sesión local",
        "loginOut": "Salir",
        "continueOnYourWay": "Sigue yendo"
    },
    "register": {
        "registerAnAccount": "Cuenta registrada",
        "register": "Registro"
    },
    "userCenter": {
        "personalInformation": "Datos personales",
        "modifyInformation": "Modificar la información",
        "changePassword": "Modificar la contraseña",
        "cancelAccount": "Cancelación de la cuenta",
        "exitAccount": "Cuenta de salida",
        "change": "Modificación",
        "maxCharLimitTip": "La longitud del nombre de usuario no puede exceder de 10 caracteres chinos",
    },
    "policies": {
        "deleteAccountPrivacy": "Eliminar el Acuerdo de cuenta",
        "agreement": "Protocolo de uso",
        "privacyPolicy": "Política de privacidad"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Elija su país o región",
        "recommendedVisits": "Visitas recomendadas",
        "NorthAmerica": "América del Norte",
        "Europe": "Europa",
        "Asia": "Asia",
        "Other": "Otros",
    }
}
export const aAndL ={
    "ar": {
        "Country": "Arabia",
        "Language": "árabe"
    },
    "cs": {
        "Country": "República Checa",
        "Language": "Checo"
    },
    "de": {
        "Country": "Alemania",
        "Language": "Alemán"
    },
    "en": {
        "Country": "Reino Unido",
        "Language": "Inglés"
    },
    "es": {
        "Country": "España",
        "Language": "Español"
    },
    "fr": {
        "Country": "Francia",
        "Language": "Francés"
    },
    "he": {
        "Country": "Israel",
        "Language": "Hebreo"
    },
    "hu": {
        "Country": "Hungría",
        "Language": "Húngaro"
    },
    "it": {
        "Country": "Italia",
        "Language": "Italiano"
    },
    "ja": {
        "Country": "Japón",
        "Language": "Japonés"
    },
    "ko": {
        "Country": "Corea del Sur",
        "Language": "Coreano"
    },
    "nl": {
        "Country": "Países Bajos",
        "Language": "Holandés"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Portugués"
    },
    "pt_BR": {
        "Country": "Portugal (brasil)",
        "Language": "Portugués (brasil)"
    },
    "ru": {
        "Country": "Rusia",
        "Language": "Ruso"
    },
    "sv": {
        "Country": "Suecia",
        "Language": "Sueco"
    },
    "tr": {
        "Country": "Turquía",
        "Language": "Turco"
    },
    "uk": {
        "Country": "Ucrania",
        "Language": "Ucraniano"
    },
    "zh": {
        "Country": "China continental",
        "Language": "Chino simplificado"
    },
    "zh_tw": {
        "Country": "Taiwán, China",
        "Language": "Chino tradicional"
    },
    "Canada": {
        "Country": "Canadá",
        "Language": "Inglés"
    },
    "United_States": {
        "Country": "Estados Unidos",
        "Language": "Inglés"
    },
    "United_Kingdom": {
        "Country": "Reino Unido",
        "Language": "Inglés"
    },
    "EU_Countries": {
        "Country": "Países de la UE",
        "Language": "Inglés"
    },
    "Australia": {
        "Country": "Australia",
        "Language": "Inglés"
    },
    "globalzh": {
        "Country": "Global",
        "Language": "Chino simplificado"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Inglés"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/es.js